// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Dmk","label":"styles_label__mFk0D"};